<template>
    <div
        class="BaseText"
    >
        <BaseHeading
            v-if="heading || preheading"
            :preheading="preheading"
            :heading="heading"
            :tag="tag"
        />

        <div
            class="wysiwyg"
            v-html="text"
        >
        </div>
    </div>
</template>
<script>
export default {
    name: 'BaseText',
    props: {
        text: {
            type: String,
            default: null
        },
        heading: {
            type: String,
            default: null,
        },
        preheading: {
            type: String,
            default: null,
        },
        tag: {
            type: String,
            default: null
        }
    }
}
</script>
<style lang="scss" scoped>

    .BaseText--legend {
        font-size: 16px;
        line-height: 16px;
    }

    h6 {
        font-size: 1rem;
        font-family: $base-font-family;
        font-weight: 700;
        line-height: 1.5;
        color: $action-color;
        text-transform: uppercase;
    }

    * {
        color: inherit;
    }
</style>
